function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createSelector } from 'reselect';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { getSecurityAttributeById } from 'invision-core/src/components/security/permission.service';
import { ADDRESS_OVERRIDE_ACCESS } from '../../security.attributes';
import i18n from 'invision-core/src/components/i18n/i18n';
import LocaleKeys from '../../locales/keys';
import { ADDRESS_STATUS_CONSTANTS } from '../../components/customer/addresses/addresses.constants';
import { COMMA, EMPTY_STRING } from '../constants/common.constants';
var AddressComponentSelector = function AddressComponentSelector(state) {
  return state.customercare.addressesComponent;
};
export var IsValidatingStatusSelector = createImmutableSelector([AddressComponentSelector], function (addressStore) {
  return addressStore.isValidating;
});
export var ValidatedAddressesSelector = createImmutableSelector([AddressComponentSelector], function (addressStore) {
  return addressStore.validatedAddresses;
});
export var UnvalidatedAddressesSelector = createImmutableSelector([AddressComponentSelector], function (addressStore) {
  return addressStore.unvalidatedAddresses;
});
export var AddressBeingValidatedSelector = createImmutableSelector([AddressComponentSelector], function (addressStore) {
  return addressStore.addressBeingValidated;
});
export var PreviouslyValidatedAddressSelector = createImmutableSelector([AddressComponentSelector], function (addressStore) {
  return addressStore.previousAddressValidated;
});
export var LastJobTokenSelector = createImmutableSelector([AddressComponentSelector], function (addressStore) {
  return addressStore.lastJobToken;
});
export var IsForceShowEditFormStatusSelector = createImmutableSelector([AddressComponentSelector], function (addressStore) {
  return addressStore.isForceShowEditForm;
});

//Below will have to change if we allow more than one address being set
export var CurrentUnvalidatedAddressSelector = createImmutableSelector([AddressComponentSelector, AddressBeingValidatedSelector], function (addressStore, addressKeyForAddressBeingValidated) {
  return addressStore.unvalidatedAddresses[addressKeyForAddressBeingValidated];
});
export var IsThereSuggestedAddressesSelector = createImmutableSelector([ValidatedAddressesSelector, AddressBeingValidatedSelector], function (validatedAddresses, addressKeyForAddressBeingValidated) {
  var validatedAddress = validatedAddresses[addressKeyForAddressBeingValidated];
  return validatedAddress && validatedAddress.SuggestedAddresses;
});
export var IsInvalidAddressOverridableScenarioSelector = createImmutableSelector([ValidatedAddressesSelector, AddressBeingValidatedSelector], function (validatedAddresses, addressKeyForAddressBeingValidated) {
  var validatedAddress = validatedAddresses[addressKeyForAddressBeingValidated];
  return validatedAddress && validatedAddress.AddressValidationStatus === ADDRESS_STATUS_CONSTANTS.INVALID;
});
export var CanUserOverrideAddressSelector = createSelector([UserSecurityAttributesSelector], function (userSecurityAttributes) {
  return getSecurityAttributeById(userSecurityAttributes, ADDRESS_OVERRIDE_ACCESS.id);
});
export var OVERRIDE_ADDRESS_VALUE = 'OVERRIDE_ADDRESS';
export var SuggestedAddressesSelector = createImmutableSelector([IsThereSuggestedAddressesSelector, ValidatedAddressesSelector, AddressBeingValidatedSelector, PreviouslyValidatedAddressSelector, CanUserOverrideAddressSelector, IsInvalidAddressOverridableScenarioSelector], function (isThereSuggestedAddresses, validatedAddresses, addressKeyBeingValidated, addressKeyForPreviouslyValidatedAddress, canUserOverrideAddress, isInvalidAddressOverrideScenario) {
  if (isThereSuggestedAddresses) {
    var addressKey = addressKeyForPreviouslyValidatedAddress ? addressKeyForPreviouslyValidatedAddress : addressKeyBeingValidated,
      radioButtonsList = validatedAddresses[addressKey].SuggestedAddresses.map(function (address) {
        return {
          displayValue: "".concat(address.LineOne, ", ").concat(address.LineTwo ? address.LineTwo + COMMA : EMPTY_STRING, " ").concat(address.City, ", ").concat(address.State, ", ").concat(address.PostalCode, ", ").concat(address.Country),
          value: address
        };
      });
    return canUserOverrideAddress ? [{
      //translate below
      displayValue: i18n.translate(LocaleKeys.ADDRESS_COMPONENT.KEEP_SUGGESTED_ADDRESS),
      value: OVERRIDE_ADDRESS_VALUE
    }].concat(_toConsumableArray(radioButtonsList)) : radioButtonsList;
  } else if (isInvalidAddressOverrideScenario && canUserOverrideAddress) {
    return [{
      displayValue: i18n.translate(LocaleKeys.ADDRESS_COMPONENT.KEEP_SUGGESTED_ADDRESS),
      value: OVERRIDE_ADDRESS_VALUE
    }];
  }
  return [];
});
export var MduRangeSelector = createImmutableSelector([AddressComponentSelector], function (addressStore) {
  return addressStore.mduRange;
});